'use strict';

import _, { get, set, union } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import CompanyDetails from './Header/Details';
import SubNav from './SubNav';
import * as asyncActions from '../../../../redux/actionCreators/async';
import * as syncActions from '../../../../redux/actionCreators/sync';
import * as companyApi from '../../../../redux/actionCreators/async/companies';
import * as companyStore from '../../../../redux/actionCreators/sync/companies';
import * as jobRequestApi from '../../../../redux/actionCreators/async/jobrequests';
import * as jobRequestStore from '../../../../redux/actionCreators/sync/jobrequests';
import * as ui from '../../../../redux/actionCreators/sync/ui';
import Worksheet from '../../../../common/components/Worksheet';
import TackIcon from '../../../../common/svgs/TackIcon';

import { updatePins } from '../../../../redux/actionCreators/async/employees';

function CompanyWorksheet(props) {

  const companyId = parseInt(props.params.companyId, 10) || 0;

  // pin functions
  const isPinned = () => {
    return _.indexOf(get(props.pinnedData, 'companies', []), companyId) >= 0;
  }

  const handleTogglePin = () => {
    return () => {
      let newPinnedData = props.pinnedData;
      if (isPinned()) {
        _.pull(newPinnedData.companies, companyId)
      }
      else {
        set(newPinnedData, 'companies', union(get(newPinnedData, 'companies', []), [companyId]));
      }

      props.dispatch(updatePins(newPinnedData, (err, pins) => {
        if (!err) {
          props.dispatch(syncActions.loadPins(pins))}
        }
      ));
    }
  }

  const pin = <div className='pin' onClick={handleTogglePin()}> <TackIcon /> <span className='pin-text'>{isPinned() ? 'unpin' : 'pin'}</span></div>;

  return (
    <Worksheet
      baseRoute='/admin/companies'
      dispatch={props.dispatch}
      location={props.location}
      pin={pin}
      >

      <div key='Card'>
        <CompanyDetails companyId={companyId} />
      </div>

      <div key='SubNav'>
        <SubNav location={props.location.pathname} companyId={companyId}/>
      </div>

      {
        props.children
      }
    </Worksheet>
  );
}

export default connect((store) => {
  return {
    staticData: store.staticData,
    ui: store.ui,
    pinnedData: get(store, 'pins.pinned', {})
  };
})(CompanyWorksheet);


export function OnEnterRefreshCompany(store) {
  return (nextState, replace, cb) => {

    const id = _.toNumber(nextState.params.companyId);
    const state = store.getState();
    const groups = state.staticData.companyStatus;
    const getCompanyById = (companyId) => store.dispatch(asyncActions.getCompanyById(companyId));
    const getCompanyJobRequestsList = (companyId) => store.dispatch(jobRequestApi.getCompanyJobRequestsList(companyId));
    const getCompanyContacts = (companyId) => store.dispatch(companyApi.getCompanyContacts(companyId));

     getCompanyById(id)
        .then((data) => {

          store.dispatch(syncActions.getCompanyInfo({company: data.items[0], groups}));
          return Promise.all([getCompanyJobRequestsList(id), getCompanyContacts(id)]);

        })
        .then(([jobRequests, contactsData]) => {

          store.dispatch(jobRequestStore.updateCompanyJobRequests(jobRequests));

          const contacts = get(contactsData, 'body.data.items', []);
          store.dispatch(companyStore.updateCompanyContacts(contacts));

          if(cb) {
            return cb();
          }

          console.error('cb is undefined.');

        })
        .catch(err => console.error('error update store', err));

  };
}



// WEBPACK FOOTER //
// ./shared/react/admin/Company/Worksheet/index.js